<template>
    <div id="toaster">
        <div v-for="toast in toasts" v-bind:key="toast.c" :class="toast.type" @click="_close(toast.c)">
            <div class="close">
                <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="m14.1225324 12.0002502 9.4377019-9.43809548c.5863543-.58587837.5863543-1.53649231 0-2.12237069-.5863542-.58637871-1.5359279-.58637871-2.1222822 0l-9.4377019 9.43809543-9.4382023-9.43809543c-.58635425-.58637871-1.53592795-.58637871-2.12228221 0-.58635425.58587838-.58635425 1.53649232 0 2.12237069l9.43820225 9.43809548-9.43820225 9.4380954c-.58635425.5858784-.58635425 1.5364923 0 2.1223707.29317713.292689.67740927.4392837 1.06114111.4392837s.76796398-.1465947 1.0611411-.439784l9.4382023-9.4380955 9.4377019 9.4380955c.2931771.2931893.6774093.439784 1.0611411.439784s.767964-.1465947 1.0611411-.439784c.5863543-.5858784.5863543-1.5364923 0-2.1223707z" fill="#000" fill-rule="evenodd"/></svg>
            </div>
            {{ toast.msg }}
        </div>
    </div>
</template>

<script>
export default {
  data () {
    return {
      c: 0,
      toasts: []
    }
  },
  methods: {
    _toast (type, msg) {
      // Increment
      const c = this.c++

      // Add toast
      this.toasts.push({
        c: c,
        msg: msg,
        type: type
      })

      // Close toast automatically
      setTimeout(() => { this._close(c) }, 4000)
    },
    _close (c) {
      for (var idx = 0; idx < this.toasts.length; idx++) {
        if (this.toasts[idx].c === c) this.toasts.splice(idx, 1)
      }
    },
    error (msg) {
      this._toast('error', msg)
    },
    success (msg) {
      this._toast('success', msg)
    }
  }
}
</script>

<style scoped>

#toaster {
    bottom: 0;
    position: absolute;
    right: 0;
    width: 30em;
}

#toaster > div {
    border-radius: 0.3em;
    cursor: pointer;
    margin: 1em;
    padding: 1em 3em 1em 1em;
    position: relative;
    text-align: center;
    z-index: 40;
}

#toaster > div.error {
    background-color: #f2dede;
    border-color: #dca7a7;
    color: #a94442;
}

#toaster > div.error path {
  fill: #a94442;
}

#toaster > div.success {
    background-color: #dff0d8;
    border-color: #b2dba1;
    color: #3c763d;
}

#toaster > div.success path {
  fill: #3c763d;
}

#toaster .close {
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  position: absolute;
  right: 1em;
  top: 0;
}

#toaster .close > svg {
  height: 1em;
}

</style>
